import { render, staticRenderFns } from "./ViewActivity.vue?vue&type=template&id=c68a874c&scoped=true"
import script from "./ViewActivity.vue?vue&type=script&lang=js"
export * from "./ViewActivity.vue?vue&type=script&lang=js"
import style0 from "./ViewActivity.vue?vue&type=style&index=0&id=c68a874c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68a874c",
  null
  
)

export default component.exports